import { createPrintOptions } from '@/utils/printOptions'
import {
	isStillHiding,
	pruneHiddenAnnouncements,
	pruneShownAnnouncements,
} from '@/utils/announcementRetention'

export default {
	namespaced: true,
	state: {
		token: false,
		authToken: '',
		wsToken: '',
		userId: 0,
		storeId: null,
		storeName: '',
		storeList: [],
		permissions: [],
		loginRole: '',
		authority: '',
		switchRole: '',
		selectedMenu: '',
		loginStoreId: null,
		reload: false,
		shopOrderStatus: true,
		buyerType: null,
		account: null,
		role: false,
		manager: true,
		super: false,
		hasPos: false,
		posMac: '',
		posMacSecond: '',
		posDeviceId: '',
		posDeviceIdSecond: '',
		printerboxPrinterName: '',
		printerboxPrinterNameSecond: '',
		hasTag: false, //標籤機
		tagMac: '',
		tagDeviceId: '',
		rememberAccount: '',
		backPosCheckoutMode: '', // 後台結帳模式
		announcementDisplayList: [], //公告列表
		hiddenAnnouncements: [], // 永久已讀（知道了）公告列表
		shownAnnouncements: [], // 本次 session 已自動顯示過的公告 id（冷啟動重置，見 store/index.js）
		announcementDisplayShow: {
			id: null,
			status: false,
		}, //公告彈窗
		mobile: false, //手機模式
		deviceFontSize: null, // 裝置字級 小1/中2/大3；null=本機尚未設定，由 getter 取預設中(2)
		adminLinePaySwitch: false, // 總後台店家linePay支付開關
		adminIPassSwitch: false, //  總後台店家Ipass支付開關
		idleOrderReminderSwitch: false, // 閒置訂單提醒開關
		idleOrderReminderMinutes: 30, // 閒置訂單提醒分鐘設定
		active: true, //當前是否focus app
		iosVersion: null, //目前IOS APP版本
		androidVersion: null, //目前Android APP版本
		invoiceSwitch: {
			admin: false, //總後台
			store: false, //店家
		}, //電子發票是否啟用
		// 合約啟用日未到時，是否仍顯示電子發票設定頁籤（供管理人員提前協助店家串接）。
		// 僅管顯示，功能啟用一律看 invoiceSwitch.admin && invoiceSwitch.store。
		// 獨立存放而非併入 invoiceSwitch，因 InvoiceSet 存檔時會整包覆寫 invoiceSwitch。
		invoiceSettingVisible: false,
		deliveryPlatformSwitch: {
			admin: false, // 是否啟用外送平台
			uberEats: false, // 是否啟用UberEats
			uberInvoiceSwitch: false, // 是否啟用Uber電子發票
			foodPanda: false, //是否啟用FoodPanda
			foodPandaInvoiceSwitch: false, //是否啟用FoodPanda電子發票
		},
		uberEatsStoreAuthorization: false, // Uber Eats 店家授權是否成功
		systemModule: {
			posOrder: false,
			frontOrder: false,
			mobileOrder: false,
		}, // 系統模組
		mobileOrderPreviewAllowed: false,
		whatsEatSwitch: false, // whatsEat開關
		printClient: false,
		payMethods: [], // 店家付款方式
		bookPrintNowSwitch: true, //是否立即出單
		bookOrderPrepareTime: 60, //預約訂單準備時間(分鐘)
		bookOrderPresetSortSwitch: false, //預約訂單排序開關
		kitchenAreaSwitch: false, // 廚房分區功能開關
		printErrorLogSwitch: false, // 列印錯誤 log 上傳開關
		printWarnLogSwitch: false, // 列印警告 log 上傳開關
		// 補印單據上次勾選（裝置偏好），結構同 utils/printOptions.js。
		// 預設寫出完整結構而非 null —— persistedstate 還原是 deepmerge(initial, saved)，殘缺的舊資料會自動補回 false。
		lastPrintOptions: createPrintOptions(), // 訂單管理（含待取餐詳情彈窗）
		lastReportPrintOptions: createPrintOptions(), // 報表（與訂單管理各記一份）
		deliveryFinishReminderDismissedDates: {}, // 各店家外送完成提示當日不再提醒的日期
	},
	mutations: {
		setDeliveryFinishReminderDismissedDate($, { storeId, date }) {
			$.deliveryFinishReminderDismissedDates = {
				...$.deliveryFinishReminderDismissedDates,
				[storeId]: date,
			}
		},
		setToken($, val) {
			$.token = val
		},
		setAuthToken($, val) {
			$.authToken = val
		},
		setWsToken($, val) {
			$.wsToken = val
		},
		clearAuthTokens($) {
			$.authToken = ''
			$.wsToken = ''
		},
		setUserId($, val) {
			$.userId = val
		},
		setRole($, val) {
			$.role = val
		},
		setStoreId($, val) {
			$.storeId = val
		},
		setStoreName($, val) {
			$.storeName = val
		},
		setPermissions($, val) {
			$.permissions = val
		},
		setLoginRole($, val) {
			$.loginRole = val
		},
		setAuthority($, val) {
			$.authority = val
		},
		setSwitchRole($, val) {
			$.switchRole = val
		},
		setSelectedMenu($, val) {
			$.selectedMenu = val
		},
		setLoginStoreId($, val) {
			$.loginStoreId = val
		},
		setReload($, val) {
			$.reload = val
		},
		setShopOrderStatus($, val) {
			$.shopOrderStatus = val
		},
		setBuyerType($, val) {
			$.buyerType = val
		},
		setAccount($, val) {
			$.account = val
		},
		setStoreList($, val) {
			$.storeList = val
		},
		setManager($, val) {
			$.manager = val
		},
		setSuper($, val) {
			$.super = val
		},
		setHasPos($, val) {
			$.hasPos = val
		},
		setPosMac($, val) {
			$.posMac = val
		},
		setPosDeviceId($, val) {
			$.posDeviceId = val
		},
		setPosMacSecond($, val) {
			$.posMacSecond = val
		},
		setPosDeviceIdSecond($, val) {
			$.posDeviceIdSecond = val
		},
		setPrinterboxPrinterName($, val) {
			$.printerboxPrinterName = val
		},
		setPrinterboxPrinterNameSecond($, val) {
			$.printerboxPrinterNameSecond = val
		},
		setHasTag($, val) {
			$.hasTag = val
		},
		setTagMac($, val) {
			$.tagMac = val
		},
		setTagDeviceId($, val) {
			$.tagDeviceId = val
		},
		setRememberAccount($, val) {
			$.rememberAccount = val
		},
		setBackPosCheckoutMode($, val) {
			$.backPosCheckoutMode = val
		},
		setBackPosTagMode($, val) {
			$.backPosTagMode = val
		},
		setAnnouncementDisplayList($, val) {
			$.announcementDisplayList = val

			// 清理只看公告本身是否過期，不看是否還在當前清單中（原因見 utils/announcementRetention.js）
			$.hiddenAnnouncements = pruneHiddenAnnouncements(
				$.hiddenAnnouncements,
				new Date(),
			)
			$.shownAnnouncements = pruneShownAnnouncements($.shownAnnouncements)
		},
		// 登出／清除登入狀態用：只清畫面資料與 session 級的已顯示記錄，保留 hiddenAnnouncements，
		// 讓登出、被踢出或重新登入後不會再次主動彈出已按過「知道了」的公告
		clearAnnouncementDisplay($) {
			$.announcementDisplayList = []
			$.shownAnnouncements = []
		},
		addHiddenAnnouncement($, announcement) {
			if (!Array.isArray($.hiddenAnnouncements)) $.hiddenAnnouncements = []
			// 檢查是否已存在
			const exists = $.hiddenAnnouncements.some(
				hidden => hidden.id === announcement.id,
			)

			if (!exists) {
				$.hiddenAnnouncements.push({
					id: announcement.id,
					endTime: announcement.endTime,
				})
			}
		},
		removeHiddenAnnouncement($, id) {
			$.hiddenAnnouncements = ($.hiddenAnnouncements || []).filter(
				hidden => hidden.id !== id,
			)
		},
		addShownAnnouncement($, id) {
			if (!Array.isArray($.shownAnnouncements)) $.shownAnnouncements = []
			if (!$.shownAnnouncements.includes(id)) $.shownAnnouncements.push(id)
		},
		removeShownAnnouncement($, id) {
			$.shownAnnouncements = ($.shownAnnouncements || []).filter(x => x !== id)
		},
		clearShownAnnouncements($) {
			$.shownAnnouncements = []
		},
		setAnnouncementDisplayShow($, val) {
			$.announcementDisplayShow = val
				? val
				: {
						status: !$.announcementDisplayShow,
						id: null,
				  }
		},
		setMobile($, val) {
			$.mobile = val
		},
		setDeviceFontSize($, val) {
			$.deviceFontSize = val
		},
		setAdminLinePaySwitch($, val) {
			$.adminLinePaySwitch = val
		},
		setAdminIPassSwitch($, val) {
			$.adminIPassSwitch = val
		},
		setIdleOrderReminderSwitch($, val) {
			$.idleOrderReminderSwitch = val
		},
		setIdleOrderReminderMinutes($, val) {
			$.idleOrderReminderMinutes = val
		},
		setActive($, val) {
			$.active = val
		},
		setIosVersion($, val) {
			$.iosVersion = val
		},
		setAndroidVersion($, val) {
			$.androidVersion = val
		},
		setInvoiceSwitch($, val) {
			$.invoiceSwitch = val
		},
		setInvoiceSettingVisible($, val) {
			$.invoiceSettingVisible = !!val
		},
		setSystemModule($, val) {
			$.systemModule = val
		},
		setMobileOrderPreviewAllowed($, val) {
			$.mobileOrderPreviewAllowed = !!val
		},
		resetMobileOrderAccess($) {
			$.mobileOrderPreviewAllowed = false
			$.systemModule.mobileOrder = false
		},
		setDeliveryPlatformSwitch($, val) {
			$.deliveryPlatformSwitch = val
		},
		setUberEatsStoreAuthorization($, val) {
			$.uberEatsStoreAuthorization = val
		},
		setWhatsEatSwitch($, val) {
			$.whatsEatSwitch = val
		},
		setPrintClient($, val) {
			$.printClient = val
		},
		setPayMethods($, val) {
			$.payMethods = val
		},
		setKitchenAreaSwitch($, val) {
			$.kitchenAreaSwitch = val
		},
		setBookOrderPresetSortSwitch($, val) {
			$.bookOrderPresetSortSwitch = val
		},
		setBookPrintNowSwitch($, val) {
			$.bookPrintNowSwitch = val
		},
		setBookOrderPrepareTime($, val) {
			$.bookOrderPrepareTime = val
		},
		setPrintErrorLogSwitch($, val) {
			$.printErrorLogSwitch = val
		},
		setPrintWarnLogSwitch($, val) {
			$.printWarnLogSwitch = val
		},
		setLastPrintOptions($, val) {
			$.lastPrintOptions = val
		},
		setLastReportPrintOptions($, val) {
			$.lastReportPrintOptions = val
		},
	},
	actions: {},
	getters: {
		// 裝置字級，預設中(2)
		deviceFontSize: $ => $.deviceFontSize || 2,
		// 獲取應該顯示的公告（排除永久已讀的）
		getDisplayableAnnouncements: $ => {
			const now = new Date()
			const hiddenIds = ($.hiddenAnnouncements || [])
				.filter(hidden => isStillHiding(hidden.endTime, now))
				.map(hidden => hidden.id)

			return $.announcementDisplayList.filter(
				announcement => !hiddenIds.includes(announcement.id),
			)
		},
		// 需自動彈出者：排除永久已讀，也排除已顯示過的
		getUnshownAnnouncements: ($, getters) => {
			const shown = $.shownAnnouncements || []
			return getters.getDisplayableAnnouncements.filter(
				announcement => !shown.includes(announcement.id),
			)
		},
	},
}
